export class PermisosTabla {
    tabla: string;
    perfil: string;
    acceso: string;

    constructor(tabla: string, perfil: string, acceso: string) {
        this.tabla = tabla;
        this.perfil = perfil;
        this.acceso = acceso;
    }
}